module.exports = __webpack_public_path__ + "static/media/honda-go-drive.2421b2fa.jpg";